import sanityClient from '@sanity/client';

export default sanityClient({
projectId: "m0uq2kd4",
dataset: "production",


})